const path:string = "package/yxx/sound/"
const longHuPath:string = "package/longhudou/sound/"
const deZhouPath:string = "package/texasholdem/sound/"
const biPaiPath:string = "package/bipai/sound/"
const cpPath: string = path + 'cp/'
import AudioManager from "../../../../manager/audio_manager";
import YXXTableSound from "../sound_yxx_ctr";
const { ccclass, property } = cc._decorator;
@ccclass
export default class CpTableSound extends YXXTableSound{

    //播放点数
    playDianShu(dianshu:number){
        let name = dianshu.toString()
        this.playSound(cpPath + name, name)
    }

    playBtn(){
        let name = "button"
        this.playSound(longHuPath + name, name)
    }

    //播放押注
    playBet(isBet:Boolean){
        let name = 'bet'
        this.playSound(cpPath + name, name)
    }

    playStartOrBetBet(isStart){
        if(isStart){
            let name = 'specialCard'
            let p = biPaiPath
            this.playSound(p + name, name)            
        }
        
        let name = isStart ? "start_bet" : "stop_bet"
        this.playSound(longHuPath + name, name)
    }


    //数字归位
    playNumOut(){
        let name = 'allin'
        this.playSound(deZhouPath + name, name)
    }

    //摇
    playYaoGu(){
        let name = "shake_box"
        this.playSound(cpPath + name, name)  
    }

    playOpenResult(){
        let name = "open_box"
        this.playSound(cpPath + name, name)  
    }


    playBgm(){
        this.playMusic(cpPath + "cai_piao", "cai_piao")
    }

}